import axios from "axios";

export default axios.create({
	baseURL: process.env.GATSBY_WORDPRESS_BASE_URL
});

export const axiosPrivate = axios.create({
	baseURL: process.env.GATSBY_WORDPRESS_BASE_URL,
	headers: { "Content-Type": "Application/json" },
	withCredentials: true
});